import { createContext, useContext } from 'react';

// Вихід — забуваємо прив'язаний chatId і повертаємось на екран введення
// коду входу (KeyScreen). Значення дає AppInner (App.jsx); кнопка «Вийти»
// в налаштуваннях його викликає.
export const LogoutContext = createContext(() => {});

export const useLogout = () => useContext(LogoutContext);
